import { render } from "./Hex18Project.vue?vue&type=template&id=70049aec&scoped=true"
const script = {}

import "./Hex18Project.vue?vue&type=style&index=0&id=70049aec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70049aec"]])

export default __exports__